import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./ContactPage.css";

const SUPPORT_EMAIL = "support@hostingnoodle.com";

const OFFICE_ADDRESS = [
  "60 Tottenham Court Road",
  "Office 950",
  "Fitzrovia",
  "London",
  "W1T 2EW",
];

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact from Hosting Noodle: ${name || "No name"}`);
    const body = encodeURIComponent(
      `${message || "(No message)"}\n\n---\nFrom: ${name || "—"} (${email || "—"})`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <Navbar />
      <main className="hn-contact-main">
        <Container className="py-4 py-md-5">
          <h1 className="hn-contact-title">Contact Us</h1>
          <p className="hn-contact-intro text-muted mb-4">
            We aim to respond within 24 hours. Support is available Mon–Fri, 9am–5pm GMT.
          </p>
          <Row className="g-4">
            <Col lg="5">
              <Card className="hn-contact-card h-100">
                <CardBody className="p-4">
                  <div className="hn-contact-icon-wrap mb-3">
                    <i className="fas fa-envelope hn-contact-icon" aria-hidden="true" />
                  </div>
                  <h2 className="hn-contact-heading">Support</h2>
                  <p className="text-muted mb-3">
                    Get in touch with our team for help or enquiries.
                  </p>
                  <a href={`mailto:${SUPPORT_EMAIL}`} className="hn-contact-email">
                    {SUPPORT_EMAIL}
                  </a>
                  <p className="small text-muted mt-2 mb-0">
                    We aim to respond within 24 hours.
                  </p>
                </CardBody>
              </Card>
              <Card className="hn-contact-card mt-4">
                <CardBody className="p-4">
                  <div className="hn-contact-icon-wrap mb-3">
                    <i className="fas fa-location-dot hn-contact-icon" aria-hidden="true" />
                  </div>
                  <h2 className="hn-contact-heading">Registered Office</h2>
                  <address className="hn-contact-address mb-0">
                    {OFFICE_ADDRESS.map((line, i) => (
                      <span key={i}>
                        {line}
                        {i < OFFICE_ADDRESS.length - 1 && <br />}
                      </span>
                    ))}
                  </address>
                </CardBody>
              </Card>
            </Col>
            <Col lg="7">
              <Card className="hn-contact-card">
                <CardBody className="p-4">
                  <h2 className="hn-contact-heading mb-3">Send us a message</h2>
                  <p className="text-muted small mb-3">
                    Fill in the form below. Submitting will open your email client with your message addressed to us.
                  </p>
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="contact-name">Name</Label>
                      <Input
                        id="contact-name"
                        type="text"
                        placeholder="Your name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        autoComplete="name"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="contact-email">Email</Label>
                      <Input
                        id="contact-email"
                        type="email"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="contact-message">Message</Label>
                      <Input
                        id="contact-message"
                        type="textarea"
                        rows={5}
                        placeholder="Your message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      />
                    </FormGroup>
                    <Button type="submit" color="warning" className="hn-contact-submit">
                      Open email to send
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;
